import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {
    getReportsIsbnChangedReportGenerateUrl,
    getReportsIsbnChangedReportUrl,
    getReportsIsbnCountUrl, getReportsIsbnGenerateUrl,
    getReportsIsbnUrl,
    getReportsPrintsCountUrl,
    getReportsPrintsGenerateUrl,
    getReportsPrintsUrl
} from '../app.urls';
import {IsbnModel} from '../models/isbn.model';

@Injectable()
export class ReportService {
    constructor(private http: HttpClient) {
    }

    /**
     * Count number of reperts(ISBN) ready to export
     *
     * @returns {Observable<any>} count of reports to expert
     */
    getIsbnReportsCount() {
        return this.http
            .get(getReportsIsbnCountUrl());
    }
    /**
     * Count number of reperts(PV) ready to export
     *
     * @returns {Observable<any>} count of reports to expert
     */
    getPvReportsCount() {
        return this.http
            .get(getReportsPrintsCountUrl());
    }

    getPublicationForIsbnReport() {
        return this.http
            .get(getReportsIsbnUrl());
    }
    getPublicationForPrintsReport() {
        return this.http
            .get(getReportsPrintsUrl());
    }
    generateIsbnReport() {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsIsbnGenerateUrl(),{ headers: headers, responseType: 'blob' as 'json' });
    }
    generatePrintsReport(publicationIds) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .post(getReportsPrintsGenerateUrl(),publicationIds, { headers: headers, responseType: 'blob' as 'json' });
    }
    downloadIsbnReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsIsbnGenerateUrl()+'/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    getIsbnChangedReportNewData() {
        return this.http
            .get(getReportsIsbnChangedReportUrl());
    }
    completeIsbnChagedReport(reportsId) {
        return this.http
            .post(getReportsIsbnChangedReportGenerateUrl(),reportsId);
    }
    downloadPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadKePrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/ke/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadBaPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/ba/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadMtPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/mt/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadSvkBbPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/SVK_BB/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadUkSavBaPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/UK_SAV_BA/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadPkNrsrPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/PK_NRSR/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadSvkKePrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/SVK_KE/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadSvkPoPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/SVK_PO/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
    downloadCvtiSrPrintReport(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http
            .get(getReportsPrintsUrl()+'/CVTI_SR/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/report.service.ts